// @vue/component
import { useAllGoalsStore } from "@/stores/WheelAnalysis/allGoals";
import { useCriticalGoalsStore } from "@/stores/WheelAnalysis/criticalGoals";
import { storeToRefs } from "pinia";
import { useChallengeStore } from "@/stores/WheelAnalysis/challenge";

export default {
    name: "PrimaryGoals",

    components: {},

    mixins: [],

    props: {},

    setup() {
        const allGoalsStore = useAllGoalsStore();

        const { selectedGoals } = storeToRefs(allGoalsStore);
        const { selectedTargets } = storeToRefs(allGoalsStore);
        const { primaryGoalsViewMode } = storeToRefs(allGoalsStore);

        const criticalGoalsStore = useCriticalGoalsStore();
        const alreadySelectedGoals = criticalGoalsStore.selectedCriticalGoals;

        const challengeStore = useChallengeStore();
        const { editMode } = storeToRefs(challengeStore);

        return {
            allGoalsStore,
            selectedGoals,
            selectedTargets,
            criticalGoalsStore,
            alreadySelectedGoals,
            primaryGoalsViewMode,
            editMode,
        };
    },

    data() {
        return {
            // ✅ keep this (it's truly component state, not localized content)
            activeGoalItem: null,
        };
    },

    computed: {
        // ✅ localized goals+targets array
        goals() {
            return this.$tm("criticalGoals.goals") || [];
        },
    },

    watch: {
        primaryGoalsViewMode: {
            handler() {
                document.getElementById("tab-selections")?.scrollIntoView({ behavior: "instant" });
            },
        },

        selectedGoals: {
            deep: true,
            handler(newSelectedGoals) {
                // Always persist the "all goals" selection if you need that endpoint
                this.allGoalsStore.selectedGoalsChanged?.();

                // Mirror to critical only in primary/secondary modes
                if (this.primaryGoalsViewMode === "primary" || this.primaryGoalsViewMode === "secondary") {
                    const next = (Array.isArray(newSelectedGoals) ? newSelectedGoals : []).map(
                        (v) => v === true || v === "true"
                    );
                    const prev = this.criticalGoalsStore.selectedCriticalGoals || [];
                    const changed = next.length !== prev.length || next.some((v, i) => v !== prev[i]);

                    if (changed) {
                        // Replace the whole array for reactivity
                        this.criticalGoalsStore.selectedCriticalGoals = [...next];
                        // Recompute A/B indexes + PUTs
                        this.criticalGoalsStore.selectedCriticalGoalsChanged?.();
                    }
                }
            },
        },

        selectedTargets: {
            deep: true,
            handler() {
                this.allGoalsStore.selectedTargetsChanged();
            },
        },
    },

    mounted() {
        this.allGoalsStore.fetchWheelAnalysis();
    },

    methods: {},
};
